import { render } from "./User.vue?vue&type=template&id=3308b708&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=3308b708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3308b708"]])

export default __exports__